var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","allow-create":"","remote":"","remote-method":_vm.onOrgSelectorQuery,"default-first-option":"","clearable":_vm.clearable,"loading":_vm.loading,"placeholder":"FID(机构名称)"},on:{"change":_vm.onChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},_vm._l((_vm.items),function(item){return _c('el-option',{key:item.schoolid,attrs:{"label":item.schoolid
        ? item.name
          ? `${item.schoolid}(${item.name})`
          : item.schoolid
        : '',"value":item.schoolid}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }